import { render, staticRenderFns } from "./Casting.vue?vue&type=template&id=02a044c8&scoped=true&"
import script from "./Casting.vue?vue&type=script&lang=js&"
export * from "./Casting.vue?vue&type=script&lang=js&"
import style0 from "./Casting.vue?vue&type=style&index=0&id=02a044c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a044c8",
  null
  
)

export default component.exports